import React from 'react';
import './LoadingWord.css';

const Loading = () => {
  return <div className="loader" />;
};

export default Loading;
